import config from 'config'
import store from 'store'
import AxSemanticsClient from 'axsemantics'

const api = {
	idm: null,
	init (token) {
		api._axsemantics = new AxSemanticsClient({
			idmBaseUrl: config.api.idm.baseUrl,
			questBaseUrl: config.api.quest.baseUrl,
			idToken: token,
			fetch: function () {
				return AxSemanticsClient.fetch.apply(this, arguments).then((arg) => {
					return Promise.resolve(arg)
				}).catch((error) => {
					if (error.response && (error.response.status < 400 || error.response.status > 499)) { // let the caller handle 4xx
						store.commit('messaging/GENERIC_REQUEST_FAILED', error)
					}
					return Promise.reject(error)
				})
			}
		})

		api.idm = api._axsemantics._idm
		api.quest = api._axsemantics._quest

		api.quest.getUser = (email) => {
			const qs = new URLSearchParams({ email }).toString()
			return api.quest.fetch(`v1/users/?${qs}`)
		}

		api.idm.users.list = () => {
			return api.idm.fetch('userlist/')
		}
		api.idm.users.get = (id) => {
			return api.idm.fetch(`userlist/${id}/`)
		}
		api.idm.users.impersonate = (id) => {
			return api.idm.fetch(`userlist/${id}/impersonate/`)
		}
		api.responseToObject = (response) => {
			return response.reduce((result, item, index, array) => {
				result[item.slug] = item
				return result
			}, {})
		}
	}
}

window.api = api // for console debug
export default api
